import { createAction } from '@reduxjs/toolkit';
import type {
  ContextControl,
  Dashboard,
  FilterControl,
  PeriodControl,
  QuickView,
  SettingsControl,
} from 'lib-analytics-types';

import { AnalyticsMeta } from './analytics.reducer';

const prefix = 'analytics';

export const analyticsActions = {
  setDashboard: createAction<{ dashboard: Dashboard }>(
    `${prefix}/setDashboard`,
  ),
  setQuickView: createAction<{ dashboard: Dashboard; quickView: QuickView }>(
    `${prefix}/setQuickView`,
  ),

  setContext: createAction<{ context: ContextControl }>(`${prefix}/setContext`),
  setPeriod: createAction<{ period: PeriodControl }>(`${prefix}/setPeriod`),
  setFilters: createAction<{ filters: FilterControl[] }>(
    `${prefix}/setFilters`,
  ),
  setSettings: createAction<{ settings: Partial<SettingsControl> }>(
    `${prefix}/setSettings`,
  ),
  setMeta: createAction<{ meta: Partial<AnalyticsMeta> }>(`${prefix}/setMeta`),

  restoreSnapshot: createAction(`${prefix}/restoreSnapshot`),
};
